module.exports = __webpack_public_path__ + "static/media/avatar.d7185574.jpg";